import enMessages from './en';
import frMessages from './fr';

const supportedLocales = {en: enMessages, fr: frMessages};
const defaultLocale = 'en';

export function loadLocale(code) {
    return supportedLocales[code] ? supportedLocales[code] : supportedLocales[defaultLocale];
}


// WEBPACK FOOTER //
// ./src/locale/index.js